import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

declare const $: (element: HTMLElement) => { modal(action: 'hide' | 'dispose'): void };

@Directive({ selector: '[videoPlayerModal]' })
export class VideoPlayerModalDirective implements AfterViewInit, OnDestroy {
  private phase: 'hidden' | 'opening' | 'shown' | 'closing' = 'hidden';
  private destroyed = false;
  private readonly showing = () => {
    this.phase = 'opening';
    // Escape the fixed camera page's stacking context, including fullscreen mode.
    (document.fullscreenElement ?? document.body).appendChild(this.element.nativeElement);
  };
  private readonly shown = () => {
    this.phase = 'shown';
    if (this.destroyed) $(this.element.nativeElement).modal('hide');
  };
  private readonly hiding = () => { this.phase = 'closing'; };
  private readonly hidden = () => {
    this.phase = 'hidden';
    if (this.destroyed) this.dispose();
  };

  constructor(private element: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    const root = this.element.nativeElement;
    root.addEventListener('show.bs.modal', this.showing);
    root.addEventListener('shown.bs.modal', this.shown);
    root.addEventListener('hide.bs.modal', this.hiding);
    root.addEventListener('hidden.bs.modal', this.hidden);
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    if (this.phase === 'hidden') this.dispose();
    else if (this.phase === 'shown') $(this.element.nativeElement).modal('hide');
  }

  private dispose(): void {
    const root = this.element.nativeElement;
    root.removeEventListener('show.bs.modal', this.showing);
    root.removeEventListener('shown.bs.modal', this.shown);
    root.removeEventListener('hide.bs.modal', this.hiding);
    root.removeEventListener('hidden.bs.modal', this.hidden);
    $(root).modal('dispose');
    root.remove();
  }
}
